import React from 'react'
import { Image, ImagePropsType } from '@deal/components'
import styles from './styles.css'
import classnames from 'classnames'

interface Props {
  contentClassName?: string
  containerClassName?: string
  imageClassName?: string
  backgroundPosition?: string
}

const BackgroundImage: React.SFC<Props & ImagePropsType> = ({
  children,
  contentClassName,
  containerClassName,
  imageClassName,
  backgroundPosition,
  htmlAttributes,
  src,
  ...rest
}) => {
  if (backgroundPosition) {
    const style: Partial<HTMLImageElement['style']> = {
      objectPosition: backgroundPosition
    }

    htmlAttributes = htmlAttributes || {}
    htmlAttributes.style = Object.assign(htmlAttributes.style || {}, style)
  }

  return (
    <div className={classnames(styles.container, containerClassName)}>
      {src && (
        <Image
          src={src}
          className={classnames(imageClassName, styles.image)}
          htmlAttributes={htmlAttributes}
          {...rest}
        />
      )}
      <div className={classnames(styles.content, contentClassName)}>{children}</div>
    </div>
  )
}

export default BackgroundImage
